import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import PlusIcon from '../../assets/icons/plus.svg?react';
import styles from './AddTreatmentPlanButton.module.css';

interface AddTreatmentPlanButtonProps {
  variant: 'empty-cell' | 'filled-cell';
  wrapperClassName: string;
  lineWrapperClassName?: string;
  isLast?: boolean;
  onActivate: (rect: DOMRect) => void;
}

export const AddTreatmentPlanButton = ({
  variant,
  wrapperClassName,
  lineWrapperClassName,
  isLast,
  onActivate
}: AddTreatmentPlanButtonProps): ReactElement => {
  const { t } = useTranslation();
  const label = t('add-treatment-plan');
  const showLine = variant === 'filled-cell' && lineWrapperClassName !== undefined;
  const lineWrapperClass = isLast
    ? `${lineWrapperClassName ?? ''} ${styles.lineWrapperLast}`
    : lineWrapperClassName;

  return (
    <>
      {showLine && (
        <div className={lineWrapperClass}>
          <span className={styles.lineStripe} />
        </div>
      )}
      <div className={wrapperClassName}>
        <button
          type="button"
          className={styles.circle}
          aria-label={label}
          title={label}
          onClick={(e) => onActivate(e.currentTarget.getBoundingClientRect())}
        >
          <PlusIcon />
        </button>
      </div>
    </>
  );
};
